module.exports = __webpack_public_path__ + "static/media/medal-gold.a6a37916.png";